export default __webpack_public_path__ + "static/media/Cypher_artwork.d1423320.png";